import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import React, { ChangeEvent } from "react";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import HookInput from "./hook-input/HookInput";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  form: UseFormReturn<FieldValues | any, any>;
  field: IField;
}
const validPhoneDigits = (val: string) => val === "" || /^[0-9]*$/.test(val);

const HookNumber: React.FC<Props> = ({ form, field }) => {
  const t = useTranslation();
  const fConfig = field.configurations;
  return (
    <Controller
      control={form.control}
      name={fConfig.key}
      rules={{
        validate: (value) =>
          fConfig.is_required && (!value || value === "")
            ? t.this_field_is_required
            : true,
      }}
      render={({ field }) => (
        <HookInput
          inputRegister={{
            //special use
            value: field.value ?? "",
            onChange: (e: ChangeEvent<HTMLInputElement>) =>
              validPhoneDigits(e.target.value) &&
              field.onChange(e.target.value),
          }}
          type="tel"
          dir="ltr"
          required={fConfig.is_required}
          label={fConfig.title}
          errorMsg={form.formState.errors[fConfig.key]?.message as string}
          placeholder={fConfig.placeholder}
          hideLabel={fConfig.hideLabel}
          hint={fConfig.hint}
        />
      )}
    />
  );
};

export default HookNumber;
